/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var e = {
  handleInterceptedEvent: function handleInterceptedEvent(e, p, t, n) {
    return e.scheduleRender(), p.properties["on".concat(n.type)].apply(p.properties.bind || t, [n]);
  }
};
export { e as defaultAdvancedProjectorOptions };